import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  year: new Date().getFullYear().toString(),
  selectedCrops: [],
  selectedSeeds: [],
  selectedStatus: [],
  selectedTillages: [],
  search: "",
  debouncedSearch: "",
  isFilterApplied: false,
};

const plantedAcresFilterSlice = createSlice({
  name: "plantedAcresFilter",
  initialState,
  reducers: {
    setYear: (state, action) => {
      state.year = action.payload;
    },
    setSelectedCrops: (state, action) => {
      state.selectedCrops = action.payload;
    },
    setSelectedSeeds: (state, action) => {
      state.selectedSeeds = action.payload;
    },
    setSelectedStatus: (state, action) => {
      state.selectedStatus = action.payload;
    },
    setSelectedTillages: (state, action) => {
      state.selectedTillages = action.payload;
    },
    setSearch: (state, action) => {
      state.search = action.payload;
    },
    setDebouncedSearch: (state, action) => {
      state.debouncedSearch = action.payload;
    },
    setIsFilterApplied: (state, action) => {
      state.isFilterApplied = action.payload;
    },
    resetPlantedAcresDrawerFilters: (state) => {
      state.selectedCrops = [];
      state.selectedSeeds = [];
      state.selectedStatus = [];
      state.selectedTillages = [];
      state.isFilterApplied = false;
    },
    resetPlantedAcresFilters: (state) => {
      state.year = new Date().getFullYear().toString();
      state.selectedCrops = [];
      state.selectedSeeds = [];
      state.selectedStatus = [];
      state.selectedTillages = [];
      state.search = "";
      state.debouncedSearch = "";
      state.isFilterApplied = false;
    },
  },
});

export const {
  setYear,
  setSelectedCrops,
  setSelectedSeeds,
  setSelectedStatus,
  setSelectedTillages,
  setSearch,
  setDebouncedSearch,
  setIsFilterApplied,
  resetPlantedAcresDrawerFilters,
  resetPlantedAcresFilters,
} = plantedAcresFilterSlice.actions;
export default plantedAcresFilterSlice.reducer;
